import OnlinePaymentSection from './OnlinePaymentSection';
export default OnlinePaymentSection;
